import {
  Area,
  CartesianGrid,
  AreaChart as RechartsArea,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

interface AreaChartProps {
  data: Array<Record<string, unknown>>
  dataKey: string
  xKey?: string
  title: string
  color?: string
}

export function AreaChart({
  data,
  dataKey,
  xKey = 'date',
  title,
  color = '#C4714A',
}: AreaChartProps) {
  return (
    <div className="rounded-lg border border-dashed border-border bg-surface p-5">
      <p className="mb-4 font-mono text-[11px] tracking-wider text-ink-faint uppercase">{title}</p>
      <ResponsiveContainer width="100%" height={220}>
        <RechartsArea data={data}>
          <defs>
            <linearGradient id={`grad-${dataKey}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.2} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="4 4" stroke="#E8E2DA" vertical={false} />
          <XAxis
            dataKey={xKey}
            tick={{ fontSize: 10, fontFamily: 'IBM Plex Mono', fill: '#9C9488' }}
            tickLine={false}
            axisLine={false}
            tickFormatter={(v: string) => {
              const d = new Date(v)
              return `${d.getMonth() + 1}/${d.getDate()}`
            }}
          />
          <YAxis
            tick={{ fontSize: 10, fontFamily: 'IBM Plex Mono', fill: '#9C9488' }}
            tickLine={false}
            axisLine={false}
            width={36}
          />
          <Tooltip
            contentStyle={{
              fontFamily: 'IBM Plex Mono',
              fontSize: 11,
              background: '#FDFBF8',
              border: '1px dashed #D4CFC8',
              borderRadius: 6,
            }}
          />
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke={color}
            strokeWidth={1.5}
            fill={`url(#grad-${dataKey})`}
          />
        </RechartsArea>
      </ResponsiveContainer>
    </div>
  )
}
